import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import { ChakraProvider,Center,Spinner,Text,Box,Flex,Spacer } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme/theme";
import { Router } from "./router/Router";
import { User } from "./types/user";
import { Amplify, Auth, Hub, I18n } from 'aws-amplify';
import { getAwsConfig } from './aws-config'
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { ListButton } from "./components/atoms/button/ListButton";

// Amplifyの日本語化
import { translations } from '@aws-amplify/ui';
translations['ja']["Change Password"] = "パスワード変更 ";
translations['ja']["Reset Password"] = "パスワードのリセット";
translations['ja']['Confirm TOTP Code'] = 'MFAコード入力';
translations['ja']['Setup TOTP'] = 'MFAセットアップ';
translations['ja']['Invalid code received for user'] = 'MFA コードが正しくない、または期限切れです';
translations['ja']['Invalid session for the user, session is expired.'] = '認証処理がタイムアウトしました。サインインに戻って、パスワード認証からMFAコード検証まで3分以内で実施してください。';
I18n.putVocabularies(translations)
I18n.setLanguage('ja');
// console.log(translations);

function App() {
  Amplify.configure(getAwsConfig());
  const [user, setUser] = useState<User | null>(null);
  const processingRef = useRef(false);
  const appType = process.env.REACT_APP_APP_TYPE;
  const basename = process.env.REACT_APP_BASENAME;
  
  useEffect(() => {
    
    if (processingRef.current === false) {
      processingRef.current = true;
      
      Hub.listen('auth', ({ payload: {event, data } }) => {
        switch (event) {
          case 'signIn':
          case 'cognitoHostedUI':
            getUser().then(userData => setUser(userData));
            break;
          case 'signOut':
            setUser(null);
            break;
          case 'signIn_failure':
          case 'cognitoHostedUI_failure':
            console.log('Sign in failure', data);
        }
        // setDefault(true);
      });
      
      getUser().then(userData => setUser(userData));
    }
  }, []);
  
  const getUser = async () => {
    try {
      const userData = await Auth.currentAuthenticatedUser();
      //console.log(userData);
      return userData;
    } catch (e) {
      return console.log('Not signed in');
    }
  }
  
  //
  return (
    <ChakraProvider theme={theme}>
      {processingRef.current === false ? (
        <Center h="100vh">
          <Spinner color="teal.500" />
        </Center>
      ) : user ? (
        <BrowserRouter basename={basename}>
          <Router />
        </BrowserRouter>
      ) : (
        <Center h="100vh">
          <Box bgColor='white' padding="50px">
            <Text>マルチクラウド障害通知システム
              {appType === 'ADMIN' && '（管理者向け）'}
              {process.env.REACT_APP_ENV_TYPE === 'DEV' ? '（開発）' :
               process.env.REACT_APP_ENV_TYPE === 'STG' && '（ステージング）'}
            </Text>
            <br />
            <Authenticator hideSignUp={true}></Authenticator>
            <Box marginLeft="14px" marginRight="14px" border="1px" borderColor="silver" color="gray" marginTop="5px" width="480px">
              <Text marginLeft="5px" fontSize="xs">■MFAコードの初期化について</Text>
              <Text marginLeft="10px" marginRight="10px" fontSize="xs">アプリの引継ぎや故障でMFA登録の初期化が必要になった場合は、ご契約サービスのポータルよりお問い合わせください。</Text>
            </Box>
            <br />
            <Flex>
              <Spacer />
              <Text>NEC社内時のみ：</Text>
              <ListButton onClick={() => Auth.federatedSignIn()}>NEC認証でサインイン</ListButton>
            </Flex>
          </Box>
        </Center>
      )}
    </ChakraProvider>
  );
}

export default App;
